/**
 * Supabase Realtime raises normal reconnection lifecycle events as `Error`s —
 * the client recovers on its own, so these are noise, not bugs:
 *
 * - `socket closed` / `transport failure` — the WebSocket dropped (tab switch,
 *   phone lock, flaky wifi). Phoenix auto-reconnects.
 * - `heartbeat timeout` — the reciprocal of the above. Auto-reconnects.
 * - `Token has expired` / `InvalidJWTToken` — a backgrounded tab freezes JS
 *   timers, so Supabase's auth auto-refresh does not fire and the JWT lapses;
 *   on wake the channel's rejoin refreshes the token and re-subscribes. Self-heals.
 *
 * Single source of truth for two layers of defense:
 * - Sentry `ignoreErrors` (`instrumentation-client.ts`) — the authoritative
 *   filter, covering EVERY capture path: our explicit `reportObservedError`, an
 *   error thrown deep inside the Supabase/Phoenix socket that a global handler
 *   catches, or an unhandled rejection. This is what an app-level allowlist
 *   alone missed — it only saw the explicit-report path.
 * - the realtime hooks' first-line `isExpectedRealtimeTransient` early-exit —
 *   avoids even capturing an event the SDK would only drop.
 */
export const REALTIME_TRANSIENT_ERROR_MESSAGES = [
  'socket closed',
  'heartbeat timeout',
  'transport failure',
  'Token has expired',
  'InvalidJWTToken',
] as const;
